import React, { useState, useEffect } from "react";
import "./Plans.css";
import "../../App.css";
import Yearly from "./Yearly";
import Monthly from "./Monthly";
import { getCurrency } from "../../utils/Utilities";
import axios from "axios";

const Plans = () => {
  const [planType, setPlanType] = useState("yearly");
  const [countryCode, setCountryCode] = useState("IN"); 
  const [currency, setCurrency] = useState({
    currencySymbol: "₹",
    currencyName: "Rupees",
  });
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(false);
 const API_BACKEND = process.env.REACT_APP_BACKEND_API;
 

//  console.log("API Backend URL:", API_BACKEND);

  // Get country first
  useEffect(() => {
    const fetchCountry = async () => {
      const result = await getCurrency();
      // console.log("Currency fetched:", result);
      setCountryCode(result?.currencyName === "Rupees" ? "IN" : "UAE");
      setCurrency(result);
    };
    
    fetchCountry();
  }, []);

  useEffect(() => {
    if (!countryCode) return; 

    const fetchPlans = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `${API_BACKEND}api/v1/plan/fatchAllPlansWithoutAuth?country=${countryCode}`
        );
        // console.log("Fetched plans:", response.data.result);
        setPlans(response.data?.result);
      } catch (err) {
        console.error("Error fetching plans:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchPlans();
  }, [countryCode]); 

  return (
    <div id="plan" className="bigwrapper">
      <div className="sectionwrapper">
        <div className="plansdiv">
          <div className="planleft">
            <div className="planswitch">
              <button
                type="button"
                onClick={() => setPlanType("yearly")}
                className={planType === "yearly" ? "active" : ""}
              >
                Yearly Plans
              </button>
              {/* <button
                type="button"
                onClick={() => setPlanType("monthly")}
                className={planType === "monthly" ? "active" : ""}
              >
                Monthly Plans
              </button> */}
            </div>
            <div>
              <h3 className="orangeheading">Pricing Chart</h3>
              <h1 className="mainsmallheading">
                Plans Designed to Grow With You
              </h1>
            </div>
            <p className="mainsmallsubheading">
              Choose the plan that fits your networking needs. Affordable,
              transparent, and built to deliver more value with every tap.
            </p>
            <div className="planswitch responsive">
              <button
                type="button"
                onClick={() => setPlanType("yearly")}
                className={planType === "yearly" ? "active" : ""}
              >
                Yearly Plans
              </button>
              {/* <button
                type="button"
                onClick={() => setPlanType("monthly")}
                className={planType === "monthly" ? "active" : ""}
              >
                Monthly Plans
              </button> */}
            </div>
          </div>
          <div className="planright">
            {loading ? (
              <div>Loading plans...</div>
            ) : (
              <>
              
              {(() => {
                const visiblePlans = plans?.filter(
                  (p) => {
                    
                    const name = p.name ? String(p.name).toLowerCase() : "";
                    return ["bb smart", "bb power", "bb os pro"].includes(name.toLowerCase());
                  }
                );
                return <Yearly currency={currency} plans={visiblePlans} />;
              })()}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Plans;